var _defs, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDirectPurchaseRecordedV1 = function SvgDirectPurchaseRecordedV1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cfdcff;}.cls-2{fill:#f5f5f5;}.cls-11,.cls-14,.cls-15,.cls-22,.cls-25,.cls-3{fill:#fff;}.cls-4{fill:#fafafa;opacity:0.8;}.cls-11,.cls-12,.cls-14,.cls-15,.cls-18,.cls-22,.cls-25,.cls-4,.cls-5,.cls-8{isolation:isolate;}.cls-14,.cls-5,.cls-8{opacity:0.1;}.cls-6{fill:#1a2e35;}.cls-7{fill:#407bff;}.cls-9{fill:#565454;}.cls-10,.cls-12{fill:#aaedeb;}.cls-11{opacity:0.6;}.cls-13{fill:#263238;}.cls-15,.cls-18{opacity:0.2;}.cls-16{fill:#ce5b51;}.cls-17{fill:#1b5998;}.cls-19{fill:#e4897b;}.cls-20{fill:#0e2d4c;}.cls-21{fill:#1d133b;}.cls-22{opacity:0.4;}.cls-23{fill:#de5753;}.cls-24{fill:#5e80e6;}.cls-25{opacity:0.7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    "data-name": "Background Simple"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.42,250.43c-2.35-29.83-60.21-78.76-39.85-103.6,25.3-30.86,121.48,12.95,164.51,4.52,46.14-9,126.41-93,167-73.47,48.18,23.24-17.62,135.67-10.87,182.55,3.79,26.35,50,84.76,29.13,105-33.1,32-134.76-20.1-184.42-16.55C201.35,351.64,111.87,402.18,85.16,379,57.52,355,117.07,284.16,114.42,250.43Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Sheet"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "432.1 83.75 432.1 271.19 433.46 274.94 280.35 274.94 278.98 83.75 432.1 83.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "432.1 83.75 432.1 271.19 432.17 276.31 280.35 274.94 278.98 83.75 432.1 83.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M336.92,101.94H294.69a2.24,2.24,0,0,1-2.24-2.24h0a2.24,2.24,0,0,1,2.24-2.24h42.23a2.24,2.24,0,0,1,2.24,2.24h0A2.24,2.24,0,0,1,336.92,101.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M413.52,120.11H311.71a2.24,2.24,0,0,1-2.24-2.24h0a2.25,2.25,0,0,1,2.24-2.24H413.52a2.24,2.24,0,0,1,2.24,2.24h0A2.24,2.24,0,0,1,413.52,120.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M413.52,128.94H294.69a2.24,2.24,0,0,1-2.24-2.24h0a2.24,2.24,0,0,1,2.24-2.24H413.52a2.24,2.24,0,0,1,2.24,2.24h0A2.24,2.24,0,0,1,413.52,128.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M413.52,138.91H294.69a2.24,2.24,0,0,1-2.24-2.24h0a2.24,2.24,0,0,1,2.24-2.24H413.52a2.24,2.24,0,0,1,2.24,2.24h0A2.24,2.24,0,0,1,413.52,138.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M413.52,148.89H294.69a2.24,2.24,0,0,1-2.24-2.24h0a2.24,2.24,0,0,1,2.24-2.25H413.52a2.24,2.24,0,0,1,2.24,2.25h0A2.24,2.24,0,0,1,413.52,148.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M413.52,158.86H294.69a2.24,2.24,0,0,1-2.24-2.24h0a2.24,2.24,0,0,1,2.24-2.24H413.52a2.24,2.24,0,0,1,2.24,2.24h0A2.24,2.24,0,0,1,413.52,158.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M413.52,168.83H294.69a2.24,2.24,0,0,1-2.24-2.24h0a2.24,2.24,0,0,1,2.24-2.24H413.52a2.24,2.24,0,0,1,2.24,2.24h0A2.24,2.24,0,0,1,413.52,168.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 292.45,
    y: 174.32,
    width: 123.31,
    height: 4.48,
    rx: 2.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M413.52,188.77H294.69a2.24,2.24,0,0,1-2.24-2.24h0a2.24,2.24,0,0,1,2.24-2.24H413.52a2.24,2.24,0,0,1,2.24,2.24h0A2.24,2.24,0,0,1,413.52,188.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M413.52,198.75H294.69a2.24,2.24,0,0,1-2.24-2.24h0a2.24,2.24,0,0,1,2.24-2.24H413.52a2.24,2.24,0,0,1,2.24,2.24h0A2.24,2.24,0,0,1,413.52,198.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M413.52,208.72H294.69a2.24,2.24,0,0,1-2.24-2.24h0a2.24,2.24,0,0,1,2.24-2.24H413.52a2.24,2.24,0,0,1,2.24,2.24h0A2.24,2.24,0,0,1,413.52,208.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M413.52,218.69H294.69a2.24,2.24,0,0,1-2.24-2.24h0a2.24,2.24,0,0,1,2.24-2.24H413.52a2.24,2.24,0,0,1,2.24,2.24h0A2.24,2.24,0,0,1,413.52,218.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M345.43,228.66H294.69a2.24,2.24,0,0,1-2.24-2.24h0a2.24,2.24,0,0,1,2.24-2.24h50.74a2.24,2.24,0,0,1,2.24,2.24h0A2.24,2.24,0,0,1,345.43,228.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "400.86 123.08 400.86 297.65 400.86 297.65 258.26 297.65 258.26 123.08 400.86 123.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "400.86 123.08 400.86 297.65 400.86 297.65 258.26 297.65 258.26 123.08 400.86 123.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.56,165.17H272.89a2.09,2.09,0,0,1-2.09-2.09h0a2.09,2.09,0,0,1,2.09-2.09H383.56a2.09,2.09,0,0,1,2.08,2.09h0A2.09,2.09,0,0,1,383.56,165.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.56,174.45H272.89a2.08,2.08,0,0,1-2.09-2.08h0a2.08,2.08,0,0,1,2.09-2.09H383.56a2.08,2.08,0,0,1,2.08,2.09h0A2.08,2.08,0,0,1,383.56,174.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.56,183.74H272.89a2.08,2.08,0,0,1-2.09-2.08h0a2.08,2.08,0,0,1,2.09-2.09H383.56a2.08,2.08,0,0,1,2.08,2.09h0A2.08,2.08,0,0,1,383.56,183.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.56,193H272.89a2.08,2.08,0,0,1-2.09-2.09h0a2.08,2.08,0,0,1,2.09-2.08H383.56a2.08,2.08,0,0,1,2.08,2.08h0A2.08,2.08,0,0,1,383.56,193Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.56,202.32H272.89a2.09,2.09,0,0,1-2.09-2.09h0a2.09,2.09,0,0,1,2.09-2.09H383.56a2.09,2.09,0,0,1,2.08,2.09h0A2.09,2.09,0,0,1,383.56,202.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 270.8,
    y: 207.43,
    width: 114.84,
    height: 4.17,
    rx: 2.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.56,220.89H272.89a2.08,2.08,0,0,1-2.09-2.08h0a2.08,2.08,0,0,1,2.09-2.09H383.56a2.08,2.08,0,0,1,2.08,2.09h0A2.08,2.08,0,0,1,383.56,220.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.56,230.18H272.89a2.08,2.08,0,0,1-2.09-2.09h0a2.08,2.08,0,0,1,2.09-2.08H383.56a2.08,2.08,0,0,1,2.08,2.08h0A2.08,2.08,0,0,1,383.56,230.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.56,239.47H272.89a2.09,2.09,0,0,1-2.09-2.09h0a2.08,2.08,0,0,1,2.09-2.08H383.56a2.08,2.08,0,0,1,2.08,2.08h0A2.09,2.09,0,0,1,383.56,239.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M383.56,248.76H272.89a2.09,2.09,0,0,1-2.09-2.09h0a2.09,2.09,0,0,1,2.09-2.09H383.56a2.09,2.09,0,0,1,2.08,2.09h0A2.09,2.09,0,0,1,383.56,248.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M320.15,258H272.89A2.08,2.08,0,0,1,270.8,256h0a2.08,2.08,0,0,1,2.09-2.09h47.26a2.08,2.08,0,0,1,2.08,2.09h0A2.08,2.08,0,0,1,320.15,258Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M296.32,138.92v7.74h-2v-7.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.93,142.89v3.77h-2v-3.2a1,1,0,0,0-1-1.1,1.18,1.18,0,0,0-1.17,1.14v3.16h-2v-6h2v1a2.18,2.18,0,0,1,2-1A2.08,2.08,0,0,1,303.93,142.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.35,142c-.33,0-.56.12-.56.37,0,.79,3.13.41,3.12,2.49,0,1.22-1.07,1.92-2.53,1.92a4.42,4.42,0,0,1-2.69-.85l.62-1.27a3.91,3.91,0,0,0,2.12.74c.36,0,.63-.13.63-.37,0-.81-3.08-.41-3.08-2.47,0-1.25,1-1.93,2.45-1.93a4.86,4.86,0,0,1,2.48.69l-.66,1.28A4.58,4.58,0,0,0,307.35,142Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.8,140.69v6h-2v-1a2.12,2.12,0,0,1-1.91,1.06,2.07,2.07,0,0,1-2.13-2.29v-3.77h2v3.21a1,1,0,0,0,1,1.08c.7,0,1.12-.56,1.12-1.35v-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.19,140.61v1.8c-1.1-.11-1.82.37-1.92,1.2v3h-2v-6h2v1A2.15,2.15,0,0,1,322.19,140.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.19,142.77v3.89h-1.93V146a2.15,2.15,0,0,1-1.8.77,1.84,1.84,0,0,1-2-1.87c0-1.14.81-1.79,2.28-1.81h1.56V143c0-.56-.39-.89-1.14-.89a4.5,4.5,0,0,0-1.78.47l-.55-1.32a6.58,6.58,0,0,1,2.79-.65C327.22,140.61,328.18,141.4,328.19,142.77Zm-1.93,1.87v-.52h-1.17c-.55,0-.83.2-.83.62s.3.67.81.67A1.18,1.18,0,0,0,326.26,144.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M335.62,142.89v3.77h-1.95v-3.2a1,1,0,0,0-1-1.1,1.18,1.18,0,0,0-1.17,1.14v3.16h-2v-6h2v1a2.19,2.19,0,0,1,2-1A2.08,2.08,0,0,1,335.62,142.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.64,142.24c-.71,0-1.19.59-1.19,1.45s.48,1.44,1.19,1.44a1.23,1.23,0,0,0,1.17-.67l1.45.83a3.15,3.15,0,0,1-5.79-1.59,3.14,3.14,0,0,1,5.76-1.67l-1.42.83A1.35,1.35,0,0,0,339.64,142.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M348.64,144.2h-4.15a1.32,1.32,0,0,0,1.35,1,2,2,0,0,0,1.41-.6l1,1a3.32,3.32,0,0,1-2.6,1.06,2.88,2.88,0,0,1-3.16-3,2.93,2.93,0,0,1,3.11-3.08C347.71,140.62,348.77,142,348.64,144.2Zm-1.9-1a1.07,1.07,0,0,0-1.11-1.15,1.23,1.23,0,0,0-1.19,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M359.48,141.64c0,1.82-1.14,2.88-3.12,2.88H355v2.14h-2v-7.74h3.4C358.34,138.92,359.48,139.91,359.48,141.64Zm-1.92.06c0-.76-.48-1.17-1.29-1.17H355v2.37h1.29A1.13,1.13,0,0,0,357.56,141.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M366.51,143.67a3.27,3.27,0,1,1-3.27-3A3,3,0,0,1,366.51,143.67Zm-4.55,0a1.3,1.3,0,1,0,1.28-1.48A1.33,1.33,0,0,0,362,143.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M369.53,138.47v8.19h-2v-8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M373,140.69v6h-2v-6ZM373,139a.9.9,0,1,1-.9-.91A.87.87,0,0,1,373,139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M377.23,142.24c-.71,0-1.19.59-1.19,1.45s.48,1.44,1.19,1.44a1.23,1.23,0,0,0,1.17-.67l1.44.83a3.15,3.15,0,0,1-5.78-1.59,2.92,2.92,0,0,1,3.09-3.08,3,3,0,0,1,2.67,1.41l-1.42.83A1.36,1.36,0,0,0,377.23,142.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M381.63,148.89a2.72,2.72,0,0,1-1.76-.62l.81-1.36a1.19,1.19,0,0,0,.8.33.76.76,0,0,0,.72-.45l.14-.28-2.47-5.82h2l1.42,3.88,1.27-3.88h1.95L384,147.24A2.33,2.33,0,0,1,381.63,148.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 270.37,
    y: 135.52,
    width: 17.04,
    height: 17.04,
    rx: 4.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 278.89,
    cy: 141.23,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278.89,144.27a5.09,5.09,0,0,0-5.09,5.09H284A5.09,5.09,0,0,0,278.89,144.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M339,275.67c3.75-.14,7.5-.2,11.25-.26l11.25-.08,11.25.08c3.75.06,7.5.12,11.25.26-3.75.14-7.5.21-11.25.26l-11.25.08-11.25-.08C346.46,275.88,342.71,275.81,339,275.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M340.15,272.54q1.62-1.11,3.33-2.1a16,16,0,0,1,3.6-1.62,4,4,0,0,1,.5-.09.51.51,0,0,1,.55.18,1.9,1.9,0,0,1,.23,1,11.87,11.87,0,0,1-.21,2c-.23,1.3-.55,2.57-.9,3.84a59.13,59.13,0,0,1-2.62,7.44,11.51,11.51,0,0,1-.93,1.77,2.25,2.25,0,0,1-.36.41.5.5,0,0,1-.34.16.39.39,0,0,1-.24-.09l-.11-.12a1.91,1.91,0,0,1-.28-1.05,13.29,13.29,0,0,1,.69-3.92,23.27,23.27,0,0,1,1.48-3.67,11.12,11.12,0,0,1,2.31-3.23,3.59,3.59,0,0,1,1.82-.86,2,2,0,0,1,1,.09,1.54,1.54,0,0,1,.73.74,5,5,0,0,0,.54.79.81.81,0,0,0,.8.26,5.16,5.16,0,0,0,1.65-1c.26-.19.52-.4.79-.59a4.45,4.45,0,0,1,.43-.26c.14-.06.35-.18.54,0,.26.33.2.67.32,1a.59.59,0,0,0,.68.43,5.88,5.88,0,0,0,1.44-1.26c.45-.48.88-1,1.31-1.47.86-1,1.7-2,2.58-3,.44-.49.88-1,1.36-1.43a7.87,7.87,0,0,1,.75-.66,2.2,2.2,0,0,1,.45-.26.65.65,0,0,1,.29-.07.39.39,0,0,1,.3.16,1.79,1.79,0,0,1,.14,1.05c0,.34-.09.66-.16,1a18,18,0,0,1-.53,1.91,19.14,19.14,0,0,1-1.57,3.64,3.41,3.41,0,0,1-.62.82.72.72,0,0,1-.58.24,2.23,2.23,0,0,1-.52-.15,2.41,2.41,0,0,1-1.32-1.61.86.86,0,0,1,.07-.62.65.65,0,0,1,.59-.31,3.55,3.55,0,0,1,1,.24c.63.22,1.23.49,1.84.75s1.2.53,1.8.77c.3.12.6.24.9.33a2.65,2.65,0,0,0,.44.09.59.59,0,0,0,.36-.08c.49-.24.82-.85,1.32-1.34a1.56,1.56,0,0,1,1-.51.49.49,0,0,1,.41.13.54.54,0,0,1,.13.4,2.5,2.5,0,0,1-.1.53c-.09.3-.12.67,0,.69s.47,0,.75-.05a5.07,5.07,0,0,0,1.66-.86,8.58,8.58,0,0,1,.83-.56,1.67,1.67,0,0,1,1.1-.27,4.14,4.14,0,0,1,1.68,1.22,4.3,4.3,0,0,0,.7.61c.12.07.22.1.25.07a2.75,2.75,0,0,0,.38-.23,15.56,15.56,0,0,0,1.48-1.25,16.68,16.68,0,0,0,2.53-2.92,3.19,3.19,0,0,0,.64-1.69c0-.59-.6-.86-1.23-1a10.83,10.83,0,0,0-3.85.05,10.11,10.11,0,0,0-1.86.53,4.15,4.15,0,0,0-.83.45c-.24.18-.46.43-.39.67s.36.43.63.57.6.24.9.36c.61.21,1.24.4,1.87.55a44.25,44.25,0,0,0,7.81.75v0a40.58,40.58,0,0,1-7.85-.57c-.64-.14-1.28-.33-1.91-.53-.31-.12-.62-.22-.93-.37a1.37,1.37,0,0,1-.77-.73,1,1,0,0,1,.48-1,4.32,4.32,0,0,1,.89-.5,9.76,9.76,0,0,1,1.91-.57,10.86,10.86,0,0,1,4-.1,2.87,2.87,0,0,1,1,.33,1.23,1.23,0,0,1,.57,1A3.61,3.61,0,0,1,381,270a16.34,16.34,0,0,1-2.59,3,17.23,17.23,0,0,1-1.52,1.29,3.43,3.43,0,0,1-.47.28.71.71,0,0,1-.67-.1,4.8,4.8,0,0,1-.79-.67,3.75,3.75,0,0,0-1.44-1.09c-.49-.07-1.05.38-1.57.75a5.56,5.56,0,0,1-1.81.94,1.47,1.47,0,0,1-1.16,0,.73.73,0,0,1-.23-.66,3.38,3.38,0,0,1,.11-.52,2.1,2.1,0,0,0,.08-.43c0-.06,0-.08,0-.06s0,0-.06,0a1.14,1.14,0,0,0-.7.38c-.45.41-.75,1-1.45,1.42a1,1,0,0,1-.59.11,2.65,2.65,0,0,1-.52-.11c-.33-.1-.64-.22-.95-.34-.61-.25-1.21-.53-1.81-.79s-1.19-.53-1.8-.75a3.34,3.34,0,0,0-.88-.22c-.21,0-.33.17-.27.45a2,2,0,0,0,1.08,1.34,1.66,1.66,0,0,0,.42.12c.08,0,.18,0,.29-.13a3.55,3.55,0,0,0,.57-.74,19.58,19.58,0,0,0,1.58-3.56,17.36,17.36,0,0,0,.54-1.87c.07-.32.13-.64.17-.95a1.57,1.57,0,0,0-.08-.88c-.09-.17-.46.05-.7.22a7,7,0,0,0-.73.62c-.48.45-.92.93-1.37,1.41-.88,1-1.73,2-2.6,2.95-.43.49-.87,1-1.32,1.46a5.72,5.72,0,0,1-1.52,1.28.73.73,0,0,1-.85-.51c-.12-.31-.11-.7-.28-.89s-.25,0-.38.05a3.1,3.1,0,0,0-.41.26c-.26.18-.52.39-.78.59a5.26,5.26,0,0,1-1.71,1,1,1,0,0,1-1-.31,4.59,4.59,0,0,1-.59-.82c-.17-.26-.35-.55-.62-.64a1.86,1.86,0,0,0-.91-.06,3.4,3.4,0,0,0-1.68.82,11.21,11.21,0,0,0-2.21,3.17,22.22,22.22,0,0,0-1.42,3.63,12.83,12.83,0,0,0-.64,3.8,1.62,1.62,0,0,0,.21.83l.05.05h0a.34.34,0,0,0,.09-.06,1.62,1.62,0,0,0,.27-.34,12,12,0,0,0,.91-1.7,57.88,57.88,0,0,0,2.68-7.37c.36-1.25.7-2.52.94-3.8a12.68,12.68,0,0,0,.22-1.93,1.87,1.87,0,0,0-.17-.88.29.29,0,0,0-.34-.09,3.69,3.69,0,0,0-.46.08,18,18,0,0,0-3.59,1.53c-1.15.63-2.28,1.3-3.38,2Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Speech_bubble",
    "data-name": "Speech bubble"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M167.83,131.78H132.92a5.07,5.07,0,0,0-5.07,5.07v33.94a5.06,5.06,0,0,0,5.07,5.06h11.17l-7.52,10.23,13-10.23h18.25a5.06,5.06,0,0,0,5.07-5.06V136.85A5.07,5.07,0,0,0,167.83,131.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M167.83,131.78H132.92a5.07,5.07,0,0,0-5.07,5.07v33.94a5.06,5.06,0,0,0,5.07,5.06h11.17l-7.52,10.23,13-10.23h18.25a5.06,5.06,0,0,0,5.07-5.06V136.85A5.07,5.07,0,0,0,167.83,131.78Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 150.38,
    cy: 153.82,
    r: 15.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148.69,160.31a1.39,1.39,0,0,1-1-.39L142,154.27a1.39,1.39,0,0,1,1.94-2l4.73,4.64,8.18-9.13a1.38,1.38,0,1,1,2.06,1.85l-9.14,10.21a1.38,1.38,0,0,1-1,.46Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M84.45,392.2l28.81-2.83V356.88h11.42v32.48l28.93,2.84a5.6,5.6,0,0,1,5.06,5.58v4.33H79.39v-4.33A5.61,5.61,0,0,1,84.45,392.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M84.45,392.2l28.81-2.83V356.88h11.42v32.48l28.93,2.84a5.6,5.6,0,0,1,5.06,5.58v4.33H79.39v-4.33A5.61,5.61,0,0,1,84.45,392.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 155.63,
    cy: 407.48,
    r: 7.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 82.44,
    cy: 407.48,
    r: 7.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M115.43,329.52h7.09a4.13,4.13,0,0,1,4.13,4.13v31.93a0,0,0,0,1,0,0H111.3a0,0,0,0,1,0,0V333.65A4.13,4.13,0,0,1,115.43,329.52Z",
    transform: "translate(237.95 695.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M115.43,329.52h7.09a4.13,4.13,0,0,1,4.13,4.13v31.93a0,0,0,0,1,0,0H111.3a0,0,0,0,1,0,0V333.65A4.13,4.13,0,0,1,115.43,329.52Z",
    transform: "translate(237.95 695.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M79.1,266.91s8.55,53.41,25.43,62.61H87.37s-17-18.2-22.12-62.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M79.1,266.91s8.55,53.41,25.43,62.61H87.37s-17-18.2-22.12-62.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M86.52,322h66.92a5,5,0,0,1,5,5v6.69a0,0,0,0,1,0,0H81.52a0,0,0,0,1,0,0V327A5,5,0,0,1,86.52,322Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 78.32,
    y: 327.81,
    width: 83.33,
    height: 5.84,
    rx: 2.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 78.32,
    y: 327.81,
    width: 83.33,
    height: 5.84,
    rx: 2.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M63.22,277.76h27.5c8,0,13.28-6.46,11.68-14.42l-2.13-10.64c-1.61-8-9.43-14.43-17.49-14.43H55.29c-8.06,0-13.29,6.46-11.69,14.43l2.14,10.64C47.34,271.3,55.17,277.76,63.22,277.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M135.06,225.65A140.17,140.17,0,0,0,143,244c1.38,2.39,2.79,4.75,4.65,6.21,2.19,1.32,5,1.57,7.88,1.8a99.46,99.46,0,0,0,13.43-.3l1.38,5.47c-8.23,3-18.88,5.79-27.46,2-7.94-4.31-12.66-15.1-16.08-22.94-.92-2.3-1.79-4.52-2.57-7l10.8-3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M130.28,221.12c3.4,1.17,6.5,6.06,15,25.64,0,0,1.38,2.4,8.31,3.89l-.63,11s-9.9-.43-12.19-2-16.07-24.22-16.07-24.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M153.62,250.66l-.63,11s-7.94-.34-11.25-1.56a4.46,4.46,0,0,1-1-.45,68.13,68.13,0,0,1-11.86-13.86c-3-4.76-5.44-8.78-5.44-8.78l6.79-15.87c3.4,1.16,6.49,6.05,15,25.62C145.31,246.75,146.69,249.16,153.62,250.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M141.74,260.09a4.46,4.46,0,0,1-1-.45c-1.32-.93-7-8-11.13-14.52A105.88,105.88,0,0,1,134,233.23S141.89,249.05,141.74,260.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M173.93,246l7.73-2.79-.95,10.35s-7.09.91-8-2.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "191.5 249.88 186.88 253.8 180.71 253.53 181.66 243.18 191.5 249.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "153.68 250.18 157.62 251.37 156.18 262.06 152.24 262.75 153.68 250.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M126.07,281.47l5.32,6.67s59.2,23.36,68.8,30.17c12.13,8.61,45.64,71.48,45.64,71.48l-12.65,9.74s-39.4-57.84-43.85-61.44-62.57-21.41-62.57-21.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M245.83,389.79l-12.65,9.74s-11.63-17-20.94-30.21c-10-14.11-20.6-29.37-22.91-31.22-3.25-2.63-35.2-12.88-52.14-18.18-6.23-2-15.53-5.13-15.53-5.13l4.41-33.32,5.32,6.67s59.51,23.59,68.8,30.17C212.32,326.92,245.83,389.79,245.83,389.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "245.82 406.35 251.91 400.23 244.16 391.08 237.07 396.47 245.82 406.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "237.07 396.47 244.16 391.08 246.48 393.82 239.68 399.42 237.07 396.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M251.18,398.33l-8,5.4a.6.6,0,0,0-.2.84h0l3.88,6.63a1.52,1.52,0,0,0,2.1.42c2.78-1.92,4-3,7.53-5.38,2.17-1.47,6.59-4.15,9.24-6.62s.14-5-1.2-4.2c-3.18,1.9-8.71,2.72-11.8,2.49A2.4,2.4,0,0,0,251.18,398.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M212.45,369.11c-9.95-14.11-20.81-29.16-23.12-31-3.25-2.63-35.2-12.88-52.14-18.18l-16.73-19.29,3.51.46c1-.16,17.73-2.16,18.14-1.24h0s38.66,8.77,49.58,14.25C198.74,317.63,208.2,352.22,212.45,369.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "201.14 404.96 208.91 401.2 204.29 382.67 196.53 386.44 201.14 404.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "196.53 386.44 204.29 382.68 206.93 393.27 199.06 396.65 196.53 386.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M209.2,400l-9.37,2.43a.61.61,0,0,0-.48.72h0l1.46,7.55a1.53,1.53,0,0,0,1.84,1.1c3.26-.9,4.77-1.49,8.88-2.59,2.53-.66,7.6-1.73,10.92-3.18s1.79-4.69.26-4.37c-3.64.75-9.12-.32-12-1.56A2.52,2.52,0,0,0,209.2,400Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M211,395.88s-16.06-75.68-18.74-79.61c-4.39-6.42-66.17-15.34-66.17-15.34l4.08-.95L126,281l-38.27-.43s.68,31.61,5.45,39.92,75.27,12.11,79.84,14,21.49,63.35,21.49,63.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M211,395.88s-16.06-75.68-18.74-79.61c-4.39-6.42-66.17-15.34-66.17-15.34l4.08-.95L126,281l-38.27-.43s.68,31.61,5.45,39.92,75.27,12.11,79.84,14,21.49,63.35,21.49,63.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "102.22 281.9 88.63 281.66 88.87 285.78 102.81 286.12 102.22 281.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "104.31 281.82 104.91 286.09 128.16 285.57 125.27 281.66 104.31 281.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.14,282.59l.4,2.82a1.44,1.44,0,0,0,1.45,1.21l4.84-.15a1.11,1.11,0,0,0,1.11-1.28l-.4-2.82a1.45,1.45,0,0,0-1.45-1.21l-4.85.15A1.11,1.11,0,0,0,116.14,282.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M88.57,281.06l37,.1a2.22,2.22,0,0,0,2.19-1.92c5.49-43.09,2.48-58.12,2.48-58.12a80.19,80.19,0,0,0-12.2-2.48,156.54,156.54,0,0,0-18.12-.39,83.2,83.2,0,0,0-12.31,1.22c-2.21.93-4.4,10.55-2.21,40.47.57,7.84.66,14.61.61,18.58A2.51,2.51,0,0,0,88.57,281.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M127.75,279.44a2,2,0,0,1-2.14,1.72l-37-.1A2.52,2.52,0,0,1,86,278.52c.06-4,0-10.74-.6-18.58q-.47-6.45-.68-11.69a157.6,157.6,0,0,1,.11-19.1c.54-6.49,1.65-9.2,2.77-9.68A86.4,86.4,0,0,1,100,218.25a156.54,156.54,0,0,1,18.12.39,79.26,79.26,0,0,1,12.2,2.49S133.25,236.36,127.75,279.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M100.36,217.81l14.39,4.9.58-4.12c-1.4-2.46-1.75-4-.57-6.87l-9.6-11C105.42,206.35,104.39,214.07,100.36,217.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.46,224.85l2.82,1.17,2.47,1.55s3.28,18.82,2.36,34.71l2.77,2.26,2.91-2.34s-3.62-29.18-4.92-34.87l.56-1.36,1.33-2.83-2.45-1.28-3.89.85H110.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M109.07,205.19l5.68,6.53a19.77,19.77,0,0,0-1,3.1c-2.4-.72-5.37-3.92-5.25-6.53A8.67,8.67,0,0,1,109.07,205.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M101.26,215.2a68.18,68.18,0,0,0,13,6.73,12.77,12.77,0,0,0,0-6.11l6.35,3.17s.53,4.93-.93,7.49L115,223.07l-5.24,4.26s-9.92-3.82-11.48-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M135.7,252.79l-9.49,13.37c-24.9,10.71-37.72-9.28-41.45-17.91a157.6,157.6,0,0,1,.11-19.1c5.07-.24,11.37-.24,13.08,1.07,3,2.27,13.29,18.22,14.83,19.39S135.7,252.79,135.7,252.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M164.59,247.16l6.35-2.29L170,255.23s-7.09.9-8-2.83l.82-3.32A2.77,2.77,0,0,1,164.59,247.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M180.09,250.21l-3.93,5.28-6.17-.26.95-10.36,8.62,3.44A1.24,1.24,0,0,1,180.09,250.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M96.61,232.19c3.81,7.13,7.62,14.76,13.29,20.1.41.35,1.09.79.81.65a24.65,24.65,0,0,0,6.21.47c15.78-.61,31.67-3.4,47.36-5.63l1.23,5.51A308.33,308.33,0,0,1,123,262.67a64.19,64.19,0,0,1-11.66.66,13.91,13.91,0,0,1-5.63-1.43c-7.8-4.49-12.48-12.33-16.79-19.73-.91-1.67-1.76-3.27-2.59-5.11l10.3-4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M87.65,219.47c-13.92,5,6.07,42.81,13.66,46.69s55.86-7.81,55.86-7.81l.9-12s-44,6.09-46,5.61c-3.16-.75-9.55-14.71-13.84-22.29A24.26,24.26,0,0,0,87.65,219.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M87.65,219.47c-13.92,5,6.07,42.81,13.66,46.69s56.31-7.86,56.31-7.86l.9-12S114,252.41,112,251.93c-3.16-.75-9.55-14.71-13.84-22.29A24.26,24.26,0,0,0,87.65,219.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "158.12 245.29 156.99 259.27 160.97 258.52 162.03 246.03 158.12 245.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.88,189.33c.55,3.23-.84,9.51-4.88,6.86S128.93,183.79,129.88,189.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M107,190.49c-1.55,7.89-2.87,12.43,0,17.4,4.35,7.49,14.91,6.35,18.8-.94,3.5-6.55,5.46-18.35-1.37-23.36A11.09,11.09,0,0,0,107,190.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.25,181.78l8.94-.41.23,5.13-.51-.28s-.57,7.49-4.85,10.05C101.27,191.85,99.57,184.62,103.25,181.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M102.33,196.18a7.55,7.55,0,0,0,2.53,5.23c2,1.76,4.2.23,4.62-2.27.37-2.26-.22-5.88-2.71-6.68A3.47,3.47,0,0,0,102.33,196.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.28,195.63c-.16.63,0,1.23.45,1.34s.89-.33,1-1,0-1.23-.45-1.33S118.45,195,118.28,195.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M125.46,197.43c-.17.64,0,1.23.45,1.34s.89-.33,1-1,0-1.23-.45-1.33S125.62,196.8,125.46,197.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M123.09,197.18a22.48,22.48,0,0,0,1.72,6,3.88,3.88,0,0,1-3.15-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.63,204.48a7.68,7.68,0,0,0,.81.27.19.19,0,0,0,.23-.14.19.19,0,0,0-.13-.24,5.1,5.1,0,0,1-3.59-3,.2.2,0,0,0-.25-.12.19.19,0,0,0-.12.24A5.35,5.35,0,0,0,117.63,204.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.67,192.77a.4.4,0,0,0,.39-.06,3.1,3.1,0,0,1,2.71-.64.39.39,0,1,0,.25-.73,3.89,3.89,0,0,0-3.44.77.38.38,0,0,0-.06.54A.44.44,0,0,0,116.67,192.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.19,195.75a.36.36,0,0,0,.23,0,.39.39,0,0,0,.3-.45,3.75,3.75,0,0,0-2.13-2.76.38.38,0,0,0-.5.21.38.38,0,0,0,.21.5,2.93,2.93,0,0,1,1.66,2.2A.37.37,0,0,0,129.19,195.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.15,188.14a3.05,3.05,0,0,0,.54.38,3.59,3.59,0,0,0,3.45.14c2.22-1.09,2.92-7.41,9.24-4.2a3.72,3.72,0,0,1,3.8,1.34c1.63,2,.5,9.28,4,8.27S133,192,133,192s-1,.62-1.55.13a3.27,3.27,0,0,0,.94-3.63s-.84,1-1.41.8a14.61,14.61,0,0,0-.95-8.74c-2-5-14.35-3.9-14.35-3.9s-1.56-2.6-7.13-.78-8.11,8.52-7.23,11.45"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Desk"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 287.3,
    y: 211.41,
    width: 29.96,
    height: 23.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 309.58,
    y: 211.41,
    width: 7.68,
    height: 23.28
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "285.58 255.25 319.45 255.25 319.45 213 308.54 213 285.58 223.99 285.58 255.25"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 308.54,
    y: 213,
    width: 10.91,
    height: 42.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 289.07,
    y: 232.32,
    width: 15.86,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 289.07,
    y: 242.46,
    width: 15.86,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 309.58,
    y: 245.65,
    width: 8.81,
    height: 6.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 274.57,
    y: 210.14,
    width: 29.96,
    height: 24.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 296.85,
    y: 210.14,
    width: 7.68,
    height: 24.55
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "272.85 255.25 306.72 255.25 306.72 213 295.81 213 272.85 223.99 272.85 255.25"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 295.81,
    y: 213,
    width: 10.91,
    height: 42.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 276.34,
    y: 232.32,
    width: 15.86,
    height: 7.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 276.34,
    y: 242.46,
    width: 15.86,
    height: 1.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 296.85,
    y: 245.65,
    width: 8.81,
    height: 6.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "251.81 415.66 257.94 415.66 268.94 262.41 260.81 262.41 251.81 415.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "251.81 415.66 257.94 415.66 268.4 270.02 268.94 262.66 260.81 262.66 260.38 270.02 251.81 415.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "260.38 269.66 268.4 269.66 268.94 262.66 260.81 262.66 260.38 269.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "206.85 415.66 212.98 415.66 213.98 262.41 205.85 262.41 206.85 415.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "205.84 262.66 206.01 287.38 206.84 415.66 212.97 415.66 213.81 287.38 213.97 262.66 205.84 262.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "205.84 262.66 206.01 287.66 213.81 287.66 213.97 262.66 205.84 262.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "141.81 415.66 147.94 415.66 158.94 262.41 150.81 262.41 141.81 415.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "141.81 415.66 147.94 415.66 158.41 270.02 158.94 262.66 150.81 262.66 150.38 270.02 141.81 415.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "150.38 269.66 158.41 269.66 158.94 262.66 150.81 262.66 150.38 269.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "321.89 415.66 328.02 415.66 319.01 262.41 310.88 262.41 321.89 415.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "310.88 262.66 311.43 270.02 321.89 415.66 328.01 415.66 319.45 270.02 319.01 262.66 310.88 262.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "319.01 262.66 310.88 262.66 311.43 269.66 319.45 269.66 319.01 262.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M146.53,258.57H323.29a2.16,2.16,0,0,1,2.16,2.16v5.51a0,0,0,0,1,0,0H144.37a0,0,0,0,1,0,0v-5.51A2.16,2.16,0,0,1,146.53,258.57Z",
    transform: "translate(469.83 524.82) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 144.37,
    y: 258.57,
    width: 181.08,
    height: 3.84,
    transform: "translate(469.83 520.98) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M140.58,259.57H329.25a2.15,2.15,0,0,0,2.16-2.16h0a2.16,2.16,0,0,0-2.16-2.16H140.58a2.17,2.17,0,0,0-2.17,2.16h0A2.16,2.16,0,0,0,140.58,259.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "288.71 255.23 288.71 251.85 290.98 251.85 288.71 250.53 290.41 250.53 288.14 249.05 285.99 249.05 285.99 247.35 288.49 247.35 285.99 246.36 285.99 242.67 288.49 242.67 288.49 240.26 290.98 240.26 288.49 239.42 288.49 237.7 290.27 237.7 288.81 236.25 287.55 234.98 248.91 234.98 248.91 236.71 246.36 236.71 249.2 237.99 249.2 239.42 243.99 239.42 243.99 242.08 241.68 242.08 243.99 243.24 243.99 246.21 245.63 246.21 245.63 247.63 248.91 247.63 248.91 251.85 247.07 251.85 248.58 253.36 248.58 255.25 288.71 255.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "288.71 255.23 288.71 251.85 290.98 251.85 288.71 250.53 290.41 250.53 288.14 249.05 285.99 249.05 285.99 247.35 288.49 247.35 285.99 246.36 285.99 242.67 288.49 242.67 288.49 240.26 290.98 240.26 288.49 239.42 288.49 237.7 290.27 237.7 288.81 236.25 287.55 234.98 248.91 234.98 248.91 236.71 246.36 236.71 249.2 237.99 249.2 239.42 243.99 239.42 243.99 242.08 241.68 242.08 243.99 243.24 243.99 246.21 245.63 246.21 245.63 247.63 248.91 247.63 248.91 251.85 247.07 251.85 248.58 253.36 248.58 255.25 288.71 255.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "288.71 255.23 288.71 251.85 290.98 251.85 288.71 250.53 290.41 250.53 288.14 249.05 285.99 249.05 285.99 247.35 288.49 247.35 285.99 246.36 285.99 242.67 288.49 242.67 288.49 240.26 290.98 240.26 288.49 239.42 288.49 237.7 290.27 237.7 288.81 236.25 287.55 234.98 267.2 234.98 267.2 236.71 264.65 236.71 267.48 237.99 267.48 239.42 262.27 239.42 262.27 242.08 259.96 242.08 262.27 243.24 262.27 246.21 263.91 246.21 263.91 247.63 267.2 247.63 267.2 251.85 265.36 251.85 266.86 253.36 266.86 255.25 288.71 255.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "249.2 239.42 267.48 239.42 249.2 238.76 249.2 239.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "248.91 247.63 267.2 247.63 267.28 248.91 248.91 247.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "245.63 246.21 263.91 246.21 245.63 246.85 245.63 246.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "248.91 251.85 267.2 251.85 248.91 251.18 248.91 251.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "248.58 253.36 266.86 253.36 266.86 254.06 248.58 253.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "243.99 242.08 262.27 242.08 243.99 241.5 243.99 242.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "248.91 236.71 267.2 236.71 248.91 236.07 248.91 236.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "288.49 237.7 269.94 237.7 288.49 238.27 288.49 237.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "267.48 239.42 288.49 239.42 269.44 240.04 267.48 239.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "262.27 242.08 288.49 242.67 288.49 242.08 262.27 242.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "262.27 243.24 275.24 243.24 262.27 243.87 262.27 243.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "285.99 246.36 267.2 246.21 285.99 245.79 285.99 246.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "285.99 247.35 266.86 247.35 285.99 247.99 285.99 247.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "288.71 250.53 267.48 250.53 267.48 251.18 288.71 250.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "288.71 251.85 273.33 251.85 288.71 252.28 288.71 251.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M239.51,250.87v3.21c0,.82-1,1.16-1.79,1.16H173.6c-.82,0-1.81-.34-1.81-1.16v-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M239.51,250.87v3.21c0,.82-1,1.16-1.79,1.16H173.6c-.82,0-1.81-.34-1.81-1.16v-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M239.51,250.87v3.21c0,.82-1,1.16-1.79,1.16H195.43c-.82,0-1.8-.34-1.8-1.16v-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M250.24,217.55l-7.64,34.63a2.59,2.59,0,0,1-2.48,2H198.43a1.68,1.68,0,0,1-1.57-2.17l7.62-34.36a2.39,2.39,0,0,1,2.48-1.7h41.7C249.78,215.91,250.48,216.42,250.24,217.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M250.24,217.55l-7.64,34.63a2.59,2.59,0,0,1-2.48,2H199.84a1.68,1.68,0,0,1-1.57-2.17l7.63-34.36a2.38,2.38,0,0,1,2.48-1.7h40.28C249.78,215.91,250.48,216.42,250.24,217.55Z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDirectPurchaseRecordedV1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Direct_Purchase_Recorded_v1.1a9fe069.svg";
export { ForwardRef as ReactComponent };